import { render } from "./GraphsAllData.vue?vue&type=template&id=353722f8"
import script from "./GraphsAllData.vue?vue&type=script&lang=js"
export * from "./GraphsAllData.vue?vue&type=script&lang=js"
script.render = render

export default script